module.exports = __webpack_public_path__ + "739c7d03ae6de27e1bc4791fe009e468.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-volleyball.png
// module id = 2591
// module chunks = 0